import { z } from 'zod';

export const districtOptionSchema = z.object({
  id: z.string(),
  code: z.string(),
  name: z.string(),
  // Carried so the UI can client-cascade the dropdown by selected state.
  stateId: z.string(),
});
export type DistrictOption = z.infer<typeof districtOptionSchema>;
